import { useEffect, useState } from 'react'

/**
 * Hook that checks if Google Analytics is properly initialized
 * Polls for up to 15 seconds before giving up
 */
const useIsGAReady = (dataLayerName = 'dataLayer') => {
	const [isReady, setIsReady] = useState<boolean>(false)

	useEffect(() => {
		if (typeof window === 'undefined') return

		// Comprehensive check for GA initialization
		const checkGAReady = () => {
			return (
				Array.isArray(window[dataLayerName]) &&
				typeof window.gtag === 'function' &&
				document.getElementById('_next-ga-init') !== null &&
				document.getElementById('_next-ga') !== null
			)
		}

		// Check immediately first
		if (checkGAReady()) {
			setIsReady(true)
			return
		}

		// Set up polling if not immediately available
		const startTime = Date.now()
		const maxCheckTime = 15000
		const pingInterval = 200

		const intervalId = setInterval(() => {
			if (checkGAReady()) {
				setIsReady(true)
				clearInterval(intervalId)
				return
			}

			if (Date.now() - startTime > maxCheckTime) {
				clearInterval(intervalId)
			}
		}, pingInterval)

		return () => clearInterval(intervalId)
	}, [dataLayerName])

	return isReady
}

export default useIsGAReady
